import { AlertTriangle, Info, XCircle } from 'lucide-react';
import type { Meldung } from '../lib/typen';

/**
 * Meldungen zur Quelle: Fehler, Warnungen, Hinweise.
 *
 * 🔴 Hier steht bewusst ALLES, auch was nur ein Hinweis ist — vor allem die nicht
 * gelesenen Spalten. Stilles Ignorieren einer Spalte ist der Fehler, der erst Wochen
 * spaeter auffaellt (§11: „Unbekannte Spalte → sichtbare Meldung").
 */
export default function MeldungsListe({ meldungen }: { meldungen: Meldung[] }) {
  if (meldungen.length === 0) return null;

  return (
    <div className="space-y-2">
      {meldungen.map((meldung, i) => (
        <div
          key={`${meldung.art}-${i}`}
          className={`flex gap-2 rounded border p-3 text-sm ${stil(meldung.art)}`}
        >
          <span className="mt-0.5 shrink-0">{symbol(meldung.art)}</span>
          <span>{meldung.text}</span>
        </div>
      ))}
    </div>
  );
}

function stil(art: Meldung['art']): string {
  if (art === 'fehler') return 'border-red-300 bg-red-50 text-red-900';
  if (art === 'warnung') return 'border-amber-300 bg-amber-50 text-amber-900';
  return 'border-[#DAD9D9] bg-[#F7F7F5] text-[#1A1A1A]';
}

function symbol(art: Meldung['art']) {
  if (art === 'fehler') return <XCircle className="h-4 w-4" />;
  if (art === 'warnung') return <AlertTriangle className="h-4 w-4" />;
  return <Info className="h-4 w-4" />;
}
